export default __webpack_public_path__ + "static/media/Service_pic3.b339fc58.png";